import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    Dispatch,
    SetStateAction,
  } from "react";
  
  interface RealTimeReverseInputFieldsContextType {
    selectedOptionJob: any;
    selectedOptionEta: any;
    selectedOptionCP: any;
    selectedOptionDA: any;
    selectedOptionBranch: any;
    selectedOptionExperience: any;
    selectedOptionEducation: Array<any>;
    selectedOptionSkill: Array<any>;
    selectedOptionLanguage: Array<any>;
    selectedOptionLicense: Array<any>;
    maxRadius: number;
    jobTitleData: string[];
    etaData: string[];
    daData: string[];
    cpData: string[];
    cityData: string[];
    skillsData: string[];
    educationData: string[];
    languageData: string[];
    licenseData: string[];
    experienceData: string[];
    setSelectedOptionJob:Dispatch<SetStateAction<any>>;
    setSelectedOptionEta:Dispatch<SetStateAction<any>>;
    setSelectedOptionCP:Dispatch<SetStateAction<any>>;
    setSelectedOptionDA:Dispatch<SetStateAction<any>>;
    setSelectedOptionBranch:Dispatch<SetStateAction<any>>;
    setSelectedOptionEducation:Dispatch<SetStateAction<any[]>>;
    setSelectedOptionSkill:Dispatch<SetStateAction<any[]>>;
    setSelectedOptionLanguage:Dispatch<SetStateAction<any[]>>;
    setSelectedOptionLicense:Dispatch<SetStateAction<any[]>>;
    setSelectedOptionExperience:Dispatch<SetStateAction<any>>;
    setMaxRadius:Dispatch<SetStateAction<number>>;
    setJobTitleData:Dispatch<SetStateAction<any[]>>;
    setEtaData:Dispatch<SetStateAction<any[]>>;
    setDAData:Dispatch<SetStateAction<any[]>>;
    setCPData:Dispatch<SetStateAction<any[]>>;
    setCityData:Dispatch<SetStateAction<any[]>>;
    setSkillsData:Dispatch<SetStateAction<any[]>>;
    setEducationData:Dispatch<SetStateAction<any[]>>;
    setLanguageData:Dispatch<SetStateAction<any[]>>;
    setLicenseData:Dispatch<SetStateAction<any[]>>;
    setExperienceData:Dispatch<SetStateAction<any[]>>;
    resetAllFields: () => void;
  }
  
  const RealTimeReverseInputFieldsContext = createContext<
  RealTimeReverseInputFieldsContextType | undefined
  >(undefined);
  
  export const useRealTimeReverseInputFieldsContext = () =>
    useContext(
        RealTimeReverseInputFieldsContext,
    ) as RealTimeReverseInputFieldsContextType;
  
  export const RealTimeReverseInputFieldsProvider: React.FC<{
    children: ReactNode;
  }> = ({ children }) => {
    const [jobTitleData, setJobTitleData] = useState<string[]>([]);
    const [etaData, setEtaData] = useState<string[]>([]);
    const [cpData, setCPData] = useState<string[]>([]);
    const [daData, setDAData] = useState<string[]>([]);
    const [cityData, setCityData] = useState<string[]>([]);
    const [experienceData, setExperienceData] = useState<string[]>([]);
    const [skillsData, setSkillsData] = useState<string[]>([]);
    const [educationData, setEducationData] = useState<string[]>([]);
    const [languageData, setLanguageData] = useState<string[]>([]);
    const [licenseData, setLicenseData] = useState<string[]>([]);
    const[maxRadius, setMaxRadius] = useState<number>(25);
    const [selectedOptionJob, setSelectedOptionJob] = useState<any>(null);
    const [selectedOptionEta, setSelectedOptionEta] = useState<any>([]);
    const [selectedOptionCP, setSelectedOptionCP] = useState<any>([]);
    const [selectedOptionDA, setSelectedOptionDA] = useState<any>([]);
    const [selectedOptionBranch, setSelectedOptionBranch] = useState<any[]>([]);
    const [selectedOptionExperience, setSelectedOptionExperience] = useState<any>(null);
    const [selectedOptionEducation, setSelectedOptionEducation] = useState<any[]>([]);
    const [selectedOptionSkill, setSelectedOptionSkill] = useState<any[]>([]);
    const [selectedOptionLanguage, setSelectedOptionLanguage] = useState<any[]>([]);
    const [selectedOptionLicense, setSelectedOptionLicense] = useState<any[]>([]);

  
    const resetAllFields = () => {
      setSelectedOptionJob(null);
      setSelectedOptionEta([]);
      setSelectedOptionCP([]);
      setSelectedOptionDA([]);
      setSelectedOptionExperience(null);
      setSelectedOptionBranch([]);
      setSelectedOptionEducation([]);
      setSelectedOptionSkill([]);
      setSelectedOptionLanguage([]);
      setSelectedOptionLicense([]);
      setMaxRadius(25);
    };
  
    const contextValues: RealTimeReverseInputFieldsContextType = {
      jobTitleData,
      etaData,
      cpData,
      daData,
      cityData,
      skillsData,
      educationData,
      languageData,
      licenseData,
      experienceData,
      maxRadius,
      selectedOptionJob,
      selectedOptionEta,
      selectedOptionCP,
      selectedOptionDA,
      selectedOptionBranch,
      selectedOptionSkill,
      selectedOptionExperience,
      selectedOptionEducation,
      selectedOptionLanguage,
      selectedOptionLicense,
      setSelectedOptionJob,
      setSelectedOptionCP,
      setSelectedOptionDA,
      setSelectedOptionEta,
      setSelectedOptionBranch,
      setSelectedOptionSkill,
      setSelectedOptionEducation,
      setSelectedOptionLanguage,
      setSelectedOptionLicense,
      setSelectedOptionExperience,
      setExperienceData,
      setJobTitleData,
      setEtaData,
      setCPData,
      setDAData,
      setCityData,
      setSkillsData,
      setEducationData,
      setLanguageData,
      setLicenseData,
      setMaxRadius,
      resetAllFields,
    };
  
    return (
      <RealTimeReverseInputFieldsContext.Provider value={contextValues}>
        {children}
      </RealTimeReverseInputFieldsContext.Provider>
    );
  };
  